var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26453 8.8133C1.39637 5.73147 3.93655 3.27344 7.05083 3.27344L17.1233 3.27344C20.2376 3.27344 22.7778 5.73147 22.9096 8.8133H1.26453Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.915 10.3242V15.1086C22.915 18.3073 20.322 20.9003 17.1233 20.9003H7.05083C3.85218 20.9003 1.25916 18.3073 1.25916 15.1086V10.3242H22.915ZM6.04358 14.8568C5.62637 14.8568 5.28815 15.195 5.28815 15.6122C5.28815 16.0294 5.62637 16.3677 6.04358 16.3677H11.0798C11.497 16.3677 11.8353 16.0294 11.8353 15.6122C11.8353 15.195 11.497 14.8568 11.0798 14.8568H6.04358Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.6dec7d175b353b876d7313841b736d35.svg";
export { ForwardRef as ReactComponent };